<template lang="pug">
.card.pb-2
  .card-body.flex-centered.flex-column
    .text-center
      i.fa.fa-unlock-alt.fa-6x
    .h3.text-center.validacao-conta-text Validação Conta
    .h4.my-2.text-center.validacao-conta-text Aumente a confiabilidade de sua conta.
    .text.mb-2.text-center.validacao-conta-text Envie fotos de seu(s) documento(s) pessoais, comprovante de residência e uma selfie para ter mais segurança em sua conta.
  .mobile-app.flex-centered.flex-column.mt-2.pt-2
    .h4.text-center Use o Aplicativo "Acesso Cidadão".
    img.img-responsive.image-qr.my-2(
      alt="Qr code para baixar o aplicativo",
      src="@/assets/qr-code.png"
    )
    .flex-centered
      a.mx-2.c-hand.tooltip(
        data-tooltip="Google Play",
        href="https://play.google.com/store/apps/details?id=com.paliari.cidadaomga",
        target="_blank"
      )
        img(src="@/assets/google-play.png")
      a.mx-2.c-hand.tooltip(
        data-tooltip="App Store",
        href="https://apps.apple.com/br/app/cidadao-maringa/id932510005",
        target="_blank"
      )
        img(src="@/assets/app-store.png")
    .text-small.text-center Baixe agora mesmo
    .text.text-center Disponível também para Android e iOS
</template>

<script>
export default {};
</script>

<style lang="stylus">
.validacao-conta-text {
  padding-left: 20%;
  padding-right: 20%;
}
</style>
